// @ts-nocheck

export const localeCodes =  [
  "en",
  "da"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_209a4d8a",
      load: () => import("#nuxt-i18n/209a4d8a" /* webpackChunkName: "locale_en_46json_209a4d8a" */),
      cache: true
    },
    {
      key: "locale_en_46json_6b10666a",
      load: () => import("#nuxt-i18n/6b10666a" /* webpackChunkName: "locale_en_46json_6b10666a" */),
      cache: true
    },
    {
      key: "locale_en_46json_27ed58e0",
      load: () => import("#nuxt-i18n/27ed58e0" /* webpackChunkName: "locale_en_46json_27ed58e0" */),
      cache: true
    },
    {
      key: "locale_en_46json_13ad7966",
      load: () => import("#nuxt-i18n/13ad7966" /* webpackChunkName: "locale_en_46json_13ad7966" */),
      cache: true
    },
    {
      key: "locale_en_46json_a5f3ecb8",
      load: () => import("#nuxt-i18n/a5f3ecb8" /* webpackChunkName: "locale_en_46json_a5f3ecb8" */),
      cache: true
    },
    {
      key: "locale_i18n_45brand_46en_46json_71c27228",
      load: () => import("#nuxt-i18n/71c27228" /* webpackChunkName: "locale_i18n_45brand_46en_46json_71c27228" */),
      cache: true
    },
    {
      key: "locale_en_46json_fa55b2e1",
      load: () => import("#nuxt-i18n/fa55b2e1" /* webpackChunkName: "locale_en_46json_fa55b2e1" */),
      cache: true
    },
    {
      key: "locale_en_46json_a9894ae0",
      load: () => import("#nuxt-i18n/a9894ae0" /* webpackChunkName: "locale_en_46json_a9894ae0" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_a258a44c",
      load: () => import("#nuxt-i18n/a258a44c" /* webpackChunkName: "locale_da_46json_a258a44c" */),
      cache: true
    },
    {
      key: "locale_da_46json_ad6bb18d",
      load: () => import("#nuxt-i18n/ad6bb18d" /* webpackChunkName: "locale_da_46json_ad6bb18d" */),
      cache: true
    },
    {
      key: "locale_da_46json_291060c5",
      load: () => import("#nuxt-i18n/291060c5" /* webpackChunkName: "locale_da_46json_291060c5" */),
      cache: true
    },
    {
      key: "locale_da_46json_12ceef0b",
      load: () => import("#nuxt-i18n/12ceef0b" /* webpackChunkName: "locale_da_46json_12ceef0b" */),
      cache: true
    },
    {
      key: "locale_da_46json_b26ffebf",
      load: () => import("#nuxt-i18n/b26ffebf" /* webpackChunkName: "locale_da_46json_b26ffebf" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "da",
    language: undefined
  }
]

